import axios from 'axios';
import history from '../history';
import Cookies from 'js-cookie';
import {URL_AKM} from '../config';

let user = JSON.parse(localStorage.getItem("user"));

const instance = axios.create({
    baseURL: URL_AKM.AKM_HOST,
    headers: {
        'Accept':  'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (user == null ? Cookies.get('Set-Cookie') : user.access_token)
    }
});

instance.defaults.withCredentials = false;
instance.interceptors.response.use(response => {
    return response;
}, error => {
    // localStorage.removeItem("user")
    // history.push('/login')
});

export default instance;